<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.8333 16.5926V9.92597H10H4.16667V16.5926M1.66667 16.5926H18.3333V6.59263L10.4231 3.50735C10.3974 3.49732 10.3845 3.4923 10.3722 3.4867C10.3609 3.48155 10.3508 3.47653 10.3399 3.47058C10.3279 3.4641 10.3152 3.45625 10.2897 3.44053C10.2018 3.38634 10.1486 3.35714 10.0923 3.34434C10.0316 3.33053 9.96845 3.33053 9.90768 3.34434C9.85136 3.35714 9.79817 3.38634 9.71029 3.44053C9.68481 3.45625 9.67207 3.4641 9.66016 3.47058C9.64923 3.47653 9.63915 3.48155 9.62782 3.4867C9.61547 3.4923 9.60261 3.49732 9.57689 3.50735L1.66667 6.59263V16.5926Z"
      stroke="white"
      stroke-width="1.67"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
